module.exports = __webpack_public_path__ + "img/825.a072064e.png";